






















import Vue from 'vue';

export default Vue.extend({
  name: 'HubLoading',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
});
